import { IconProps } from "../../utils/global-types/global-types";

const AnalyticsIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-5 h-5"}
      {...rest}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.5 4.667A2.167 2.167 0 0 1 4.667 2.5h8.666A2.167 2.167 0 0 1 15.5 4.667v8.666a2.167 2.167 0 0 1-2.167 2.167H4.667A2.167 2.167 0 0 1 2.5 13.333zM9.722 6.11a.722.722 0 0 0-1.444 0v5.778a.722.722 0 0 0 1.444 0zM6.833 8.278a.722.722 0 1 0-1.444 0v3.61a.722.722 0 0 0 1.444 0zm5.778 2.166a.722.722 0 0 0-1.444 0v1.445a.723.723 0 1 0 1.444 0z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export default AnalyticsIcon;
